import { PieChart, PieChartProps } from '../../../renderers/pie-chart/pie-chart.component';
import { IOTS_VOLUME_BY_STATUS_DONUT_CHART_DEFINITION } from './iots-volume-by-status-donut-chart.definition';
import { IOTS_VOLUME_BY_STATUS_DONUT_CHART_MOCK_DATA } from './iots-volume-by-status-donut-chart.mock';

export const IotsVolumeByStatusDonutChart = (props: PieChartProps) => (
    <PieChart
        {...props}
        variant='donut'
        showSliceValues
    />
);

IotsVolumeByStatusDonutChart.definition = IOTS_VOLUME_BY_STATUS_DONUT_CHART_DEFINITION;
IotsVolumeByStatusDonutChart.mockData = IOTS_VOLUME_BY_STATUS_DONUT_CHART_MOCK_DATA;
